import wixData from 'wix-data';
import wixUsers from 'wix-users';
import wixLocation from 'wix-location';
import { currentMember } from 'wix-members';
import wixWindow from 'wix-window';
import { updateUserEngagementScore } from 'backend/userContact';
import { setRecommendedQuiz } from 'public/setRecommendedQuiz';
import { recommendationScores } from 'public/recommendationScores.js';
import wixLocationFrontend from 'wix-location-frontend';
import { session } from 'wix-storage-frontend';
import wixWindowFrontend from 'wix-window-frontend';
import { lightbox } from 'wix-window';
import { saveCTAction } from 'public/shareMyReport.js';
import { openAccessCodeViewModal } from 'public/shareMyReportV1.js';
import { customLoginOrSignup } from 'public/customSignUpLogin';
import { reportGenNudgeMessage, isShareMyReport } from 'public/reportManager';

//const shareMyReport = wixLocation.query.shareMyReport;
//console.log('shareMyReport', isShareMyReport);

export async function testReportOwner(item) {
    const currentUrl = wixLocationFrontend.url;

    //checkduplicated reports

    let database = "";
    console.log(currentUrl.toString())
    if (currentUrl.toString().includes(`social-biases-report`)) {
        database = "resultsSocialBias"
    }
    if (currentUrl.toString().includes(`action-oriented-biases-report`)) {
        database = "resultsActionOrientedBias"
    }
    if (currentUrl.toString().includes(`interest-biases-report`)) {
        database = "resultsInterestBias"
    }
    if (currentUrl.toString().includes(`pattern-recognition-biases-report`)) {
        database = "resultsPatternRecognitionBias"
    }
    if (currentUrl.toString().includes(`stability-biases-report`)) {
        database = "resultsStabilityBias"
    }
    if (currentUrl.toString().includes(`self-related-biases-report`)) {
        database = "resultsSelfRelatedBias"
    }
    if (currentUrl.toString().includes(`life-satisfaction-results`)) {
        database = "lifeSatisfaction2Results"
    }
    if (currentUrl.toString().includes(`employment-trends-report`)) {
        database = "resultsEmploymentTrends"
    }
    if (currentUrl.toString().includes(`intentional-learning-report`)) {
        database = "intentionalLearningResults"
    }
    if (currentUrl.toString().includes(`personality-report`)) {
        database = "resultsPersonality"
    }
    if (currentUrl.toString().includes(`personal-values-report`)) {
        database = "resultsPersonalValues"
    }
    if (currentUrl.toString().includes(`results-emotional-intelligence`)) {
        database = "resultsEmotionalIntelligence"
    }
    if (currentUrl.toString().includes('entrepreneurial-competencies-report')) {
        database = "resultsEntrepreneurialCompetencies"
    }
    if (currentUrl.toString().includes(`career-quiz-report`)) {
        database = "ReportingResults"
    }
    if (currentUrl.toString().includes(`communication-styles-report`)) {
        database = "resultsCommunicationStyles"
    }
    if (currentUrl.toString().includes(`learning-mindset-report`)) {
        database = "resultsLearningMindset"
    }
    if (currentUrl.toString().includes('social-media-literacy-report')) {
        database = "resultsSocialMediaLiteracy"
    }
    if (currentUrl.toString().includes('digital-literacy-report')) {
        database = "digitalLiteracyResults"
    }
    if (currentUrl.toString().includes('talent-identifier-report')) {
        database = "resultsTalentIdentifier"
    }
    if (database != "") {
        //console.log("database diferente", database);
        wixData.query(database)
            .eq("resultId", item.resultId)
            .limit(50)
            .find()
            .then((results) => {
                // if(results.length == 1){wixLocation.to("/")}
                let reports = results.items;
                let list = []
                for (let i = 0; i < reports.length; i++) {
                    if (reports[i - 1]) {
                        if (reports[i].resultId == reports[i - 1].resultId) {
                            if (reports[i].email != "") {
                                list.push(reports[i])
                                wixData.remove(database, reports[i - 1]["_id"])
                                wixLocation.to(wixLocation.url)
                            } else {
                                list.push(reports[i - 1])
                                wixData.remove(database, reports[i]["_id"])
                                wixLocation.to(wixLocation.url)
                            }
                        }
                    }
                }
            })
    }

    //console.log("wow item", item)
    let query = wixLocation.query;
    console.log("in report owner");

    if (query.minimal == "yes") {
        // setRecommendedQuiz();
    }
    /* code for share my report feature starts */
    else if (isShareMyReport) {
        openAccessCodeViewModal(isShareMyReport);
        /*let urlPrefix = ['results-conflict-handling-styles', 'identity-quiz-results', 'interactive-styles-report', 'career-readiness-results', 'career-quiz-report', 'life-satisfaction-results', 'results-emotional-intelligence', 'personality-report', 'personal-values-report', 'entrepreneurial-competencies-report', 'communication-styles-report', 'action-oriented-biases-report', 'interest-biases-report', 'social-biases-report', 'talent-identifier-report', 'self-related-biases-report', 'stability-biases-report', 'pattern-recognition-biases-report'];
        if (urlPrefix.includes(wixLocation.prefix)) {
            console.log('Copy of conflict handling styles........');
            openAccessCodeViewModal(isShareMyReport);
        } else {
            if (wixUsers.currentUser.loggedIn) {
                console.log('Not copy of report and loggedIn........');
                wixWindow.openLightbox('Share My Report', {
                    value: "accesscode",
                    shareMyReportId: isShareMyReport,
                    saveCTAction: saveCTAction
                });
            } else {
                console.log('Not copy of conflict handling styles and not loggedIn........');
                try {
                    await customLoginOrSignup('signup')
                        .then((data) => {
                            if (data) {
                                wixWindow.openLightbox('Share My Report', {
                                    value: "accesscode",
                                    shareMyReportId: isShareMyReport,
                                    saveCTAction: saveCTAction
                                });
                            }
                        });
                } catch (error) {
                    console.log('popup closed...');
                    wixLocation.to("/my-journey");
                }

            }
        }*/
    }
    /* code for share my report feature ends */

    // $w("#mainTitle").text = "testing Owner";
    else if (wixUsers.currentUser.loggedIn) {
        console.log("loggedItemtotest:-", item);
        wixUsers.currentUser.getEmail().then((email) => {
            //console.log(email, item.email);
            // if (item.email != email && item.email != "" && item.email) {
            if (item.email && (item.email != email && item.email != "")) {
                console.log("go home logged", item.email != email && item.email != '');
                //wixLocation.to("/");
                const referalCoachEmail = wixLocation.query.referalCoachEmail;
                if (referalCoachEmail && email && referalCoachEmail == email) {
                    console.log("Allowing coach to show report of his/her referal");
                    //Allowing coach to show report of his/her referal
                    return;
                } else {
                    // if (session.getItem("keepReportOpen") != "true") {
                    //     wixLocation.to("/")
                    // }

                    if (!(session.getItem("keepReportOpen") == "true")) {
                        wixLocation.to("/")
                    }

                }
            } else if (item.email == "") {
                let diference = Date.now() - item._updatedDate;
                console.log('difference, email blank: ', diference);
                console.log('difference in minutes, email blank: ', diference / 60000);
                // let userId = wixUsers.currentUser.id;
                // console.log("userId : ", userId);
                // let userDetails = currentMember.getMember()
                //     .then((member) => {
                //         return member;
                //     })
                // console.log("userDetails : ", userDetails);

                if ((diference / 60000) <= 10) {
                    console.log('difference less than 10');
                    $w("#dynamicDataset").onReady(() => {
                        $w("#dynamicDataset").setCurrentItemIndex(1).then(() => {
                            $w("#dynamicDataset").setFieldValue("email", email);
                            $w("#dynamicDataset").save();
                            // $w("#mainTitle").text = "assigned";
                            //console.log('item: ', item);

                            let query = wixLocation.query;
                            let database = query.database
                            let resultId = item.resultId;
                            console.log("wow database...", database)
                            // $w("#mainTitle").text = "assigned";
                            wixData.query("lastQuizTaken")
                                .eq("title", email)
                                .find()
                                .then((results) => {
                                    console.log("last quiz...", results)
                                    if (results.items.length > 0) {
                                        let item = results.items[0];
                                        item[database] = resultId;
                                        item.recommendationScores = recommendationScores(item);
                                        wixData.update("lastQuizTaken", item)
                                            .then((data) => {
                                                setRecommendedQuiz();
                                                currentMember.getMember({ fieldsets: ['FULL'] })
                                                    .then((memberData) => {
                                                        console.log("woww memberData ro 1", memberData)
                                                        updateUserEngagementScore(memberData.contactId)
                                                            .then((updatedContact) => {
                                                                console.log("woww updatedEngagementScore ro 1", updatedContact)
                                                            })
                                                            .catch((error) => {
                                                                updateUserEngagementScore(memberData.contactId)
                                                                console.log("woww updatedEngagementScore ro 1 error", error);
                                                            });
                                                    })
                                            })
                                        // $w("#mainTitle").text = "last quiz updated";
                                    } else {
                                        // $w("#mainTitle").text = "last quiz added";
                                        let item = {
                                            "title": email,
                                        };

                                        item[database] = resultId;
                                        wixData.insert("lastQuizTaken", item)
                                            .then((data) => {
                                                setRecommendedQuiz();
                                                currentMember.getMember({ fieldsets: ['FULL'] })
                                                    .then((memberData) => {
                                                        console.log("woww memberData ro 2", memberData)
                                                        updateUserEngagementScore(memberData.contactId)
                                                            .then((updatedContact) => {
                                                                console.log("woww updatedEngagementScore ro 2", updatedContact)
                                                            })
                                                            .catch((error) => {
                                                                console.log("woww updatedEngagementScore ro 2 error", error);
                                                                updateUserEngagementScore(memberData.contactId)
                                                            });
                                                    })
                                            })
                                        // $w("#mainTitle").text = "last quiz added";
                                        // handle case where no matching items found
                                    }
                                    console.log("assigning email...");
                                    // currentMember.getMember({ fieldsets: ['FULL'] })
                                    //     .then((memberData) => {
                                    //         // console.log("woww memberData ro", memberData)
                                    //         updateUserEngagementScore(memberData.contactId)
                                    //             .then((updatedContact) => {
                                    //                 // console.log("woww updatedEngagementScore ro", updatedContact)
                                    //             })
                                    //             .catch((error) => {
                                    //                 console.log("woww updatedEngagementScore ro 1 error", error);
                                    //             });
                                    //     })
                                })
                                .catch((err) => {
                                    // 		let errorMsg = err;
                                });

                        })
                    })
                } else {

                    // if (session.getItem("keepReportOpen") != "true") {
                    //     console.log("go home else if diff > 10, (diference / 60000) <= 10")
                    //     wixLocation.to("/"); //restricted home redirection
                    // }

                    if (!(session.getItem("keepReportOpen") == "true")) {
                        wixLocation.to("/")
                    }

                }

            } else if (item.email) {
                setRecommendedQuiz();
                currentMember.getMember({ fieldsets: ['FULL'] })
                    .then((memberData) => {
                        console.log("woww memberData ro 3", memberData)
                        updateUserEngagementScore(memberData.contactId)
                            .then((updatedContact) => {
                                //console.log("woww updatedEngagementScore ro 3", updatedContact)
                            })
                            .catch((error) => {
                                console.log("woww updatedEngagementScore ro 3 error", error);
                                updateUserEngagementScore(memberData.contactId)
                            });
                    })
            }
        });

    } else {
        // if (item.email != "" && item.email) {
        console.log("go home in else, not logged in")
        console.log(item)

        let diference = Date.now() - item._createdDate;

        if (diference < 180000) {
            /*wixWindow.openLightbox("SIGN UP", {
                    value: "signup",
                })
                .then((receivedData) => {
                    if (receivedData.userEmail) {
                        $w("#hiddenSubscribeEmailInput").value = receivedData.userEmail;
                    }
                });*/
            console.log('difference less than 3 minutes');
            reportGenNudgeMessage();
        } else {

            // if (session.getItem("keepReportOpen") != "true") {
            //     console.log('more than 3 min');
            //     wixLocation.to("/"); //restricted home redirection
            // }

            if (!(session.getItem("keepReportOpen") == "true")) {
                wixLocation.to("/")
            }

        }

        // }
        setRecommendedQuiz();
    }
    return false;
}